export const boardTypes = {
  SENIOR: 'senior',
  JUNIOR: 'junior',
  CODE: 'code',
};

export const aiModelNames = {
  hands: 'Poses de manos',
  images: 'Clasificador de imágenes',
  objects: 'Detección de objetos',
  sounds: 'Clasificador de sonidos',
  texts: 'Clasificador de textos',
  poses: 'Poses del cuerpo',
  faces: 'Gestos de la cara',
};

export default boardTypes;
